// Copy-to-Clipboard Controller
// Copies the text content of the source target to the clipboard.
// Briefly swaps the icon to a checkmark to confirm the copy.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "icon"]

  async copy() {
    if (!this.hasSourceTarget) return
    const text = this.sourceTarget.innerText.trim()
    try {
      await navigator.clipboard.writeText(text)
      this.flashSuccess()
    } catch (_e) {
      // Fallback for older browsers / insecure contexts
      const textarea = document.createElement("textarea")
      textarea.value = text
      textarea.style.position = "fixed"
      textarea.style.opacity = "0"
      document.body.appendChild(textarea)
      textarea.select()
      try { document.execCommand("copy") } catch (_) {}
      textarea.remove()
      this.flashSuccess()
    }
  }

  flashSuccess() {
    if (!this.hasIconTarget) return
    const originalClass = this.iconTarget.className
    this.iconTarget.className = originalClass.replace(/fa-copy/, "fa-check")
    setTimeout(() => {
      this.iconTarget.className = originalClass
    }, 1500)
  }
}
